<template>
  <VModal>
    <VBlock slot="contents" :direction="Direction.column">
      <VP class="content-text" text="배민페이 비밀번호 설정 후" :size="16" />
      <VP class="content-text" text="계속 이용하실 수 있습니다" :size="16" />
      <VP class="detail-text" :color="TextColor.disable" :text="subMessage" :size="14" />
    </VBlock>
    <VBlock slot="footer" class="button-wrapper">
      <VButton class="cancel-button" :color="ButtonColor.none" :onClick="onCancel">
        <VSpan text="닫기" :size="16" />
      </VButton>
      <VButton class="ok-button" :color="ButtonColor.none" :onClick="onOK">
        <VSpan :weight="TextWeight.bold" text="비밀번호 변경하기" :size="16" />
      </VButton>
    </VBlock>
  </VModal>
</template>

<script>
import VButton, { ButtonColor } from '@/presentationals/v2/components/layouts/atoms/VButton'
import VP from '@/presentationals/v2/components/layouts/atoms/VP'
import VSpan, { TextColor, TextWeight } from '@/presentationals/v2/components/layouts/atoms/VSpan'

import VBlock, { Direction } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VModal from '@/presentationals/v2/components/layouts/molecules/VModal'

export default {
  name: 'ModalPasswordReset',
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    subMessage: {
      type: String,
      required: true
    },
    onOK: {
      type: Function,
      required: true
    },
    onCancel: {
      type: Function,
      required: true
    }
  },
  components: {
    VButton,
    VSpan,
    VP,

    VBlock,
    VModal
  },
  data() {
    return {
      ButtonColor,
      TextColor,
      TextWeight,
      Direction
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.header-text,
.content-text,
.detail-text {
  text-align: center;
  letter-spacing: -0.38px;
  line-height: 1.38;
}

.content-text {
  margin-bottom: 10px;
  line-break: pre;
}

.content-text:first-child {
  margin-bottom: 0;
}

.button-wrapper {
  border-top: 1px solid $light-gray-2;
  width: 100%;
  height: 50px;
  border-spacing: 0 0;
  border-collapse: collapse;

  .cancel-button::after {
    content: '';
    width: 1px;
    height: 100%;
    background-color: $light-gray-2;
    position: absolute;
    top: -1px;
    right: 0;
  }

  .cancel-button,
  .ok-button {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    border-top: 1px solid $white;

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      white-space: nowrap;
    }
  }
}
</style>